<template>
	<div>
		<MaterialDropdown label="Order type" v-model="order_type" :options="order_types" />

		<div class="margin-top" v-if="order_type == 'exchange'">
			<MaterialText v-model="parent_order" label="Original order" />
		</div>

		<div class="margin-top">
			<template v-if="customer.id">
				<strong>Customer</strong>
				<div class="small-margin-bottom">
					{{ customer.full_name }}
					(#{{ customer.id }})
					[<a :href="'/#/customer/' + customer.id">view</a>]
				</div>
				<button v-on:click="customer = {};" class="gray small">Select another customer</button>
			</template>
			<CustomerSearch v-else v-model="customer" />
		</div>

		<div class="margin-top">
			<button data-testid="create-order" :disabled="saving" v-on:click="create()">Create order</button>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    saving: false,
    customer: {},
    parent_order: '',
    order_type: 'styling',
    order_types: {
      styling: 'Styling',
      'styling-fee': 'Styling fee',
      exchange: 'Exchange',
      webshop: 'Webshop'
    }
  }),
  methods: {
    create () {
      console.log(this.customer)
      Vue.$api.post('/order', {
        customer_id: this.customer.id,
        order_type: this.order_type,
        parent_order_id: this.parent_order
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.created(data)
      })
    },
    created (data) {
      this.$router.push('/order/' + data.id)
    }
  }
}
</script>
